import {useEffect, useState} from 'react'
import Qualification from "../interfaces/qualifications"
import api from "../api";

const useGetSharedQualifications = (id: undefined | string) => {
    const [qualifications, setQualification] = useState<Qualification[] | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const fetchQualification = async () => {
        try {
            if (id) {
                await api.get('https://biblio.nebulalabs.cc/api/qualifications/shared/' + id + '/').then((response) => {
                    setQualification(response.data.data.qualifications)
                }).catch((err) => {
                    setError(err)
                    setQualification(null)
                    setLoading(false)
                });
            } else {
                setQualification(null)
            }
            setLoading(false)
        } catch (errorResponse) {
            if (typeof errorResponse === 'string') {
                setError(errorResponse)
            } else {
                setError("An error occurred.")
            }
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchQualification()
    }, [])

    return {qualifications, loading, error, setQualification}
}

export default useGetSharedQualifications
